import axios from "axios";
import urls from "../../urls";
import { getFirebaseIDToken } from "../firebase/firebase";

/**
 * Offertes (BMX-58): mailen en omzetten gaan via de API, omdat daar post naar de klant en een
 * Exact-order uit voortkomen. Beide achter `quotes.manage`. Aanpassen gebeurt rechtstreeks in
 * Firestore (zie de offerte-detailpagina).
 */

/**
 * Mailt de huidige versie van de offerte, met PDF. `email` leeg = het adres van de klant op de
 * offerte. Geeft `{ at, to, by, version }`.
 */
export const sendQuote = async (quoteId, email) => {
  const idToken = await getFirebaseIDToken();
  const response = await axios.post(
    urls.quoteSend(quoteId),
    { email: email || null },
    { headers: { Authorization: idToken, "Content-Type": "application/json" } },
  );
  return response.data;
};

/**
 * Zet de offerte om in een bestelling op rekening. `products` zijn de regels zoals ze in de order
 * komen (opnieuw verdeeld over voorraad, zie splitQuoteLinesForOrder).
 * Geeft `{ orderDocumentId, orderId, savedToExact, confirmationSent }`.
 */
export const convertQuote = async (quoteId, { products, partialDelivery, expectedShippingDate }) => {
  const idToken = await getFirebaseIDToken();
  const response = await axios.post(
    urls.quoteConvert(quoteId),
    { products, partialDelivery: !!partialDelivery, expectedShippingDate: expectedShippingDate || null },
    { headers: { Authorization: idToken, "Content-Type": "application/json" } },
  );
  return response.data;
};

/** De Nederlandse foutmelding van de API, of de fallback. */
export const getQuoteApiError = (error, fallback) => error?.response?.data?.message || fallback;
